module.exports = __webpack_public_path__ + "static/media/22.85d8cc0e.svg";